function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledMultiCardsCarouselTabsComponent } from "./multi-cards-carousel-tabs-component.scss";
import SlidingCardGridBaseComponent from "segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/sliding-card-grid-base-component";
import Colors from "/styles/colors";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import { BRAND_BLACK_BACKGROUND_COLOR } from "styles/color-consts";
import PictureComponent from "/components/core/picture/picture-component";
const SubCard = ({ image, backImage, backgroundColor })=>/*#__PURE__*/ _jsx("div", {
        className: "small-card",
        style: {
            backgroundColor: Colors[backgroundColor]
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-inner",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "card-front",
                    children: /*#__PURE__*/ _jsx(PictureComponent, {
                        src: image
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "card-back",
                    children: /*#__PURE__*/ _jsx(PictureComponent, {
                        src: backImage
                    })
                })
            ]
        })
    });
const ProductCard = ({ cardText, image, backgroundColor })=>/*#__PURE__*/ _jsx("div", {
        className: "wide-card",
        style: {
            backgroundColor: Colors[backgroundColor]
        },
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card-content",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "image-wrapper",
                    children: /*#__PURE__*/ _jsx(PictureComponent, {
                        src: image
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-wrapper",
                    children: /*#__PURE__*/ _jsx(Paragraph, {
                        body: cardText
                    })
                })
            ]
        })
    });
const getCardsRow = (subCards)=>/*#__PURE__*/ _jsx("div", {
        className: "cards-row",
        children: subCards.map((card, index)=>card.isProductCard ? /*#__PURE__*/ _jsx(ProductCard, {
                cardText: card.cardText,
                backgroundColor: card.backgroundColor,
                image: card.image
            }, index) : /*#__PURE__*/ _jsx(SubCard, {
                image: card.image,
                backImage: card.backImage,
                backgroundColor: card.backgroundColor
            }, index))
    });
const MultiCardsCarouselTabsComponent = ({ cards, carouselTitle, wideCardImageWidth, wideCardTextSize, carouselTitleAdvancedConfig })=>{
    const itemRenderer = (card)=>/*#__PURE__*/ _jsxs("div", {
            className: "main-card-grid",
            children: [
                getCardsRow(card === null || card === void 0 ? void 0 : card.firstRowCards),
                getCardsRow(card === null || card === void 0 ? void 0 : card.secondRowCards)
            ]
        });
    return /*#__PURE__*/ _jsx(StyledMultiCardsCarouselTabsComponent, {
        wideCardImageWidth: wideCardImageWidth,
        wideCardTextSize: wideCardTextSize,
        children: /*#__PURE__*/ _jsx(SlidingCardGridBaseComponent, {
            cards: cards,
            cardsToShow: 1,
            customItemRenderer: itemRenderer,
            removeArrows: true,
            carouselTitle: _object_spread_props(_object_spread({}, carouselTitle, carouselTitleAdvancedConfig), {
                arrowColor: Colors[BRAND_BLACK_BACKGROUND_COLOR]
            })
        })
    });
};
export default MultiCardsCarouselTabsComponent;
